<template>
    <modal ref="modal" style="z-index: 9999" class="fade" header="error" :needFooter="true">
        <template v-slot:header>
            <div class="me-3">
                <span class="fw-bolder h3" @click="$refs.modal.close()" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fal fa-times text-white"></i>
                </span>
            </div>
            <div class="w-100 pe-3 text-truncate">
                <span class="fw-bolder h4" v-if="user">Admin - {{ user.screen_name }}</span>
            </div>
        </template>
        <div v-if="user">
            <toggle @click="toggleFlag" :status="user.flagged">Flag</toggle>
        </div>

        <template v-slot:footer>
            <button @click="$refs.modal.close()" class="btn rounded-pill btn-secondary">{{ $t('app.close') }}</button>
        </template>
    </modal>
</template>

<script>
export default {
    name: "admin-modal",
    data() {
        return {
            user: false
        }
    },
    mounted() {
        emitter.on('admin', (id) => {
            this.getUserData(id);
        })
    },
    methods: {
        getUserData(id) {
            this.user = false;
            $api.admin.getUserData(id).then(resp => {
                this.user = resp.data;
                this.$refs.modal.open();
            })
        },
        toggleFlag() {
            $api.admin.toggleFlag({user_id: this.user.user_id}).then(resp => {
                this.user = resp.data;
                emitter.emit('flag',resp.data)
            })
        }
    },
    components: {
        toggle: require('../btn/toggle-btn').default
    }
}
</script>

<style scoped>

</style>
